
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { loadTexts } from '../../../../config/texts';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Card,
  Divider,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Add, Save } from '@material-ui/icons';

import { upperFirst } from '../../../../util';
import styles from './styles';

import {
  courseTitleChanged,
  courseSubjectChanged,
  courseNumberChanged,
  courseUniversityChanged,
} from './actions';
import { addCourse, editCourse } from '../../actions';
const TEXT_KEY = "courses";

class AddCourse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      mode: props.mode,
      course: props.course,
      texts: loadTexts(TEXT_KEY, props.locale)
    };
    this._onClick = this._onClick.bind(this);
    this._onChangeText = this._onChangeText.bind(this);
    this._onChangeUniversity = this._onChangeUniversity.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { open, mode, course } = nextProps;
    this.setState({ open, mode, course });
  }

  _onChangeText(field) {
    return event => {
      this.props[`course${_.upperFirst(field)}Changed`](event.target.value);
    };
  }

  _onClick() {
    const { mode } = this.state;
    const { subject, number, course, title, add } = this.props;
    const courseInput = {
      title,
      subject,
      number,
    };
    if (mode === 'add') {
      if (add) {
        this.props.addCourse({ university: this.props.courseUniversity, courseInput })
          .then(() => this.props.onSubmit());
      } else {
        this.props.onSubmit();
      }
    } else { // mode === edit
      this.props.editCourse({ course, courseInput })
        .then(() => this.props.onSubmit());
    }
  }

  _onChangeUniversity(event) {
    this.props.courseUniversityChanged(event.target.value)
  }

  renderTextFields(classes) {
    const { universities, courseUniversity } = this.props;
    const { texts } = this.state;
    const field = ['title', 'subject', 'number'];

    return (
      <div className={classes.textFieldContainer}>
        {field.map(f => (
          <TextField
            id={f}
            key={f}
            label={upperFirst(texts.fields[f])}
            className={classNames(classes.textField, classes[`textField-${f}`])}
            margin="normal"
            value={this.props[f]}
            onChange={this._onChangeText(f)}
          />
        ))}
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="university">{texts.labels.institution}</InputLabel>
          <Select
            value={courseUniversity}
            onChange={this._onChangeUniversity}
            input={<Input name="university" id="university" />}
          >
            {_.map(universities, u => (
              <MenuItem key={u._id} value={u._id}>{u.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }

  render() {
    const { onClose, classes, message } = this.props;
    const { open, mode, texts: { pop_up } } = this.state;

    return (
      <Modal
        aria-labelledby="Add Course"
        aria-describedby="Input a new course and add it to the database"
        open={open}
        onClose={() => onClose('edit')}
      >
        <Card className={classes.card}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="title" color="inherit">
                {mode === 'edit' ? pop_up.edit : pop_up.add}
              </Typography>
            </Toolbar>
          </AppBar>
          {message !== '' && (
            <Typography className={classes.message} color="secondary">
              {message}
            </Typography>
          )}
          {this.renderTextFields(classes)}
          <Divider />
          <div className={classes.buttonContainer}>
            <Button
              color="primary"
              variant="raised"
              className={classes.button}
              onClick={this._onClick}
            >
              {mode === 'add' && (
                <React.Fragment>
                  <Add className={classes.icon} />
                  {pop_up.button_text.add}
                </React.Fragment>
              )}
              {mode === 'edit' && (
                <React.Fragment>
                  <Save className={classes.icon} />
                  {pop_up.button_text.save}
                </React.Fragment>
              )}
            </Button>
          </div>
        </Card>
      </Modal>
    );
  }
}

AddCourse.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['add', 'edit']).isRequired,
  onSubmit: PropTypes.func,
  addCourse: PropTypes.func.isRequired,
  editCourse: PropTypes.func.isRequired,
  add: PropTypes.bool,
  // courseTitleChanged: PropTypes.func.isRequired,
  // courseSubjectChanged: PropTypes.func.isRequired,
  // courseNumberChanged: PropTypes.func.isRequired,
  courseUniversityChanged: PropTypes.func.isRequired,
  message: PropTypes.string,
};

AddCourse.defaultProps = {
  onSubmit: () => {},
  add: true,
  message: '',
};

const mapStateToProps = state => {
  const {
    auth: { selectedUniversity, data: { user: { universities } } },
    courses: { input: { title, subject, number, university } },
  } = state;
  return {
    selectedUniversity,
    universities,
    title,
    subject,
    number,
    courseUniversity: university,
    locale: state.appState.locale,
  };
};

const mapDispatchToProps = dispatch => ({
  addCourse: params => dispatch(addCourse(params)()),
  editCourse: params => dispatch(editCourse(params)()),
  courseTitleChanged: params => dispatch(courseTitleChanged(params)),
  courseSubjectChanged: params => dispatch(courseSubjectChanged(params)),
  courseNumberChanged: params => dispatch(courseNumberChanged(params)),
  courseUniversityChanged: params => dispatch(courseUniversityChanged(params)),
});

export default compose(
  withStyles(styles, { name: 'AddCourse' }),
  connect(mapStateToProps, mapDispatchToProps)
)(AddCourse);



// WEBPACK FOOTER //
// ./src/modules/courses/components/AddCourse/index.js